<div class="loadingSpinner">
  <div class="loadingSpinner-spinner"></div>
  @if (message) {
    <p class="loadingSpinner-message">{{message}}</p>
  }
</div>